// extracted by mini-css-extract-plugin
export default {"main":"QRCode_main__6E02V","header":"QRCode_header__VhbfD","qrcode":"QRCode_qrcode__9jZBc","addressBox":"QRCode_addressBox__1PPNl"};